import { render } from "./IconLogo.vue?vue&type=template&id=18a3e572"
import script from "./IconLogo.vue?vue&type=script&lang=js"
export * from "./IconLogo.vue?vue&type=script&lang=js"
script.render = render

export default script